import React, { useCallback, useState } from 'react';
import { useDistribution } from '../../../../hooks';
import { CreateRecipient } from '../../../../dtos';
import { ConfirmModal } from '../../../../components';
import { DeleteIcon, VoucherIcon } from '../../../../components/icons';
import { RecipientModal, PlusMinusAmount } from '../index';
import { Container, LeftSide, RightSide, RightSideResume } from './styles';

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    resume?: boolean;
}

const Recipients: React.FC<Props> = ({ resume = false }) => {
    const [selectedRecipiet, setSelectedRecipient] = useState<CreateRecipient | null>(null);
    const [showRecipientModal, setShowRecipientModal] = useState<boolean>(false);
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState<boolean>(false);
    const [selectedIndex, setSelectedIndex] = useState<number>(-1);

    const { recipients, removeRecipient, plusRecipientAmount, minusRecipientAmount } = useDistribution();

    const handleRemoveRecipient = useCallback((index: number) => {
        setShowConfirmDeleteModal(true);
        setSelectedIndex(index);
    }, []);

    const handleConfirmRemoveRecipient = useCallback(() => {
        if (selectedIndex !== -1)
            removeRecipient(selectedIndex);

        setSelectedIndex(-1);
        setShowConfirmDeleteModal(false);
    }, [removeRecipient, selectedIndex]);

    return (
        <>
            {showRecipientModal && selectedRecipiet && (
                <RecipientModal
                    title="Editar destinatário"
                    recipientData={{
                        recipient: selectedRecipiet,
                        index: selectedIndex
                    }}
                    handleClose={() => {
                        setSelectedRecipient(null);
                        setSelectedIndex(-1);
                        setShowRecipientModal(false);
                    }}
                />
            )}
            {showConfirmDeleteModal && (
                <ConfirmModal
                    title="Excluir destinatário"
                    content="Deseja realmente excluir este destinatário?"
                    cancelButtonLabel="Não"
                    confirmButtonLabel="Sim, excluir"
                    handleClose={() => setShowConfirmDeleteModal(false)}
                    handleConfirmCancel={handleConfirmRemoveRecipient}
                />
            )}
            <Container>
                {!resume && (
                    <span>Adicione o(s) destinatário(s) da cortesia:</span>
                )}
                <ul>
                    {recipients.map((recipient, index) => (
                        <li
                            id={`distribution.recipients${index}.box`}
                            key={index}
                            onClick={() => {
                                if (resume) {
                                    setSelectedRecipient(recipient);
                                    setSelectedIndex(index);
                                    setShowRecipientModal(true);
                                }
                            }}
                        >
                            {!resume && (
                                <strong>{recipient.email}</strong>
                            )}
                            <div>
                                <LeftSide>
                                    {resume && (
                                        <strong>{recipient.email}</strong>
                                    )}
                                    <small>{recipient.name}</small>
                                    <small>{recipient.phoneNumber}</small>
                                </LeftSide>
                                {resume ? (
                                    <RightSideResume>
                                        <VoucherIcon />
                                        <span>{recipient.amount}</span>
                                    </RightSideResume>
                                ) : (
                                    <RightSide>
                                        <DeleteIcon
                                            id={`distribution.recipients${index}.deletebutton`}
                                            iconColor="#EE1B24"
                                            onClick={() => handleRemoveRecipient(index)}
                                        />
                                        <PlusMinusAmount
                                            id={`distribution.recipients${index}`}
                                            handleMinus={() => minusRecipientAmount(index)}
                                            handlePlus={() => plusRecipientAmount(index)}
                                            amount={recipient.amount}
                                        />
                                    </RightSide>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            </Container>
        </>
    );
};

export { Recipients };
